<script>
	import CreateRule from "./CreateRule.svelte";
	import client from "src/services/client";
	export let ruleId;
	let ruleData;

	async function fetchRuleDetail(id) {
		try {
			const res = await client(`/v1/servicing/rules/${id}`, {
				method: "GET",
				version: "Tasking",
			});
			return res.data;
		} catch (error) {
			console.log(error);
		}
	}
</script>

<CreateRule isEdit={ruleId} {ruleData} {fetchRuleDetail} />
